import React from 'react';
import { KuposMap } from '../../../../common';

function Map(props) {
  return (
    <div className="recharge-map-outer">
      <div className="title-map-display font10">Dirígete a tu punto de recarga más cercano</div>
      <div className="map-div">
        <KuposMap
          t={props.t}
          showPlaceSearch={true}
          myLocation={props.myLocation}
          getRechargeLocations={props.getRechargeLocations}
        />
      </div>
    </div>
  );
}

export default Map;



// WEBPACK FOOTER //
// ./src/features/themes/my-account/RechargeWalletKupospayRecharge/components/Map.js